__turbopack_context__.v({
  "articleBodyCard": "blog-module__JrgKeG__articleBodyCard",
  "articleMetaHeader": "blog-module__JrgKeG__articleMetaHeader",
  "articleTagsBottom": "blog-module__JrgKeG__articleTagsBottom",
  "authorAvatar": "blog-module__JrgKeG__authorAvatar",
  "authorBoxAvatar": "blog-module__JrgKeG__authorBoxAvatar",
  "authorBoxCard": "blog-module__JrgKeG__authorBoxCard",
  "authorBoxContent": "blog-module__JrgKeG__authorBoxContent",
  "authorBoxDate": "blog-module__JrgKeG__authorBoxDate",
  "authorBoxLabel": "blog-module__JrgKeG__authorBoxLabel",
  "authorBoxName": "blog-module__JrgKeG__authorBoxName",
  "authorInfo": "blog-module__JrgKeG__authorInfo",
  "authorMetaRow": "blog-module__JrgKeG__authorMetaRow",
  "authorName": "blog-module__JrgKeG__authorName",
  "backLink": "blog-module__JrgKeG__backLink",
  "blogCard": "blog-module__JrgKeG__blogCard",
  "blogCardBody": "blog-module__JrgKeG__blogCardBody",
  "blogCardCategory": "blog-module__JrgKeG__blogCardCategory",
  "blogCardDate": "blog-module__JrgKeG__blogCardDate",
  "blogCardExcerpt": "blog-module__JrgKeG__blogCardExcerpt",
  "blogCardImage": "blog-module__JrgKeG__blogCardImage",
  "blogCardLink": "blog-module__JrgKeG__blogCardLink",
  "blogCardPlaceholder": "blog-module__JrgKeG__blogCardPlaceholder",
  "blogCardTitle": "blog-module__JrgKeG__blogCardTitle",
  "blogCol": "blog-module__JrgKeG__blogCol",
  "blogLinkHover": "blog-module__JrgKeG__blogLinkHover",
  "blogRow": "blog-module__JrgKeG__blogRow",
  "catBadge": "blog-module__JrgKeG__catBadge",
  "copyLinkBtn": "blog-module__JrgKeG__copyLinkBtn",
  "detailContainer": "blog-module__JrgKeG__detailContainer",
  "detailGrid": "blog-module__JrgKeG__detailGrid",
  "detailGridNoToc": "blog-module__JrgKeG__detailGridNoToc",
  "detailTitle": "blog-module__JrgKeG__detailTitle",
  "detailWrapper": "blog-module__JrgKeG__detailWrapper",
  "heroCard": "blog-module__JrgKeG__heroCard",
  "heroPlaceholder": "blog-module__JrgKeG__heroPlaceholder",
  "listingGrid": "blog-module__JrgKeG__listingGrid",
  "listingPagination": "blog-module__JrgKeG__listingPagination",
  "mainColumn": "blog-module__JrgKeG__mainColumn",
  "metaBadgeRow": "blog-module__JrgKeG__metaBadgeRow",
  "navCard": "blog-module__JrgKeG__navCard",
  "navCardLabel": "blog-module__JrgKeG__navCardLabel",
  "navCardTitle": "blog-module__JrgKeG__navCardTitle",
  "navGrid": "blog-module__JrgKeG__navGrid",
  "navSection": "blog-module__JrgKeG__navSection",
  "progressBar": "blog-module__JrgKeG__progressBar",
  "promoArt": "blog-module__JrgKeG__promoArt",
  "promoArtFilmstrip": "blog-module__JrgKeG__promoArtFilmstrip",
  "promoArtOrganiser": "blog-module__JrgKeG__promoArtOrganiser",
  "promoBtn": "blog-module__JrgKeG__promoBtn",
  "promoSidebar": "blog-module__JrgKeG__promoSidebar",
  "promoText": "blog-module__JrgKeG__promoText",
  "promoTitle": "blog-module__JrgKeG__promoTitle",
  "promoWidget": "blog-module__JrgKeG__promoWidget",
  "promoWidgetEvents": "blog-module__JrgKeG__promoWidgetEvents",
  "promoWidgetOrganiser": "blog-module__JrgKeG__promoWidgetOrganiser",
  "pubDate": "blog-module__JrgKeG__pubDate",
  "shareBtn": "blog-module__JrgKeG__shareBtn",
  "shareBtnPrimary": "blog-module__JrgKeG__shareBtnPrimary",
  "shareGrid": "blog-module__JrgKeG__shareGrid",
  "sidebar": "blog-module__JrgKeG__sidebar",
  "sidebarWidget": "blog-module__JrgKeG__sidebarWidget",
  "tagLink": "blog-module__JrgKeG__tagLink",
  "titleActions": "blog-module__JrgKeG__titleActions",
  "titleBlock": "blog-module__JrgKeG__titleBlock",
  "titleRow": "blog-module__JrgKeG__titleRow",
  "tocContainer": "blog-module__JrgKeG__tocContainer",
  "tocItem": "blog-module__JrgKeG__tocItem",
  "tocLink": "blog-module__JrgKeG__tocLink",
  "tocList": "blog-module__JrgKeG__tocList",
  "tocNumber": "blog-module__JrgKeG__tocNumber",
  "tocSidebar": "blog-module__JrgKeG__tocSidebar",
  "tocTitle": "blog-module__JrgKeG__tocTitle",
  "topHeaderRow": "blog-module__JrgKeG__topHeaderRow",
  "widgetTitle": "blog-module__JrgKeG__widgetTitle",
});
